<!-- <section class="">
<div class="position-relative ">
  <div id="carouselHPRCSSlider" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">

      <div class="carousel-item ">
        <div class="carousel-bg">
          <img src="../../assets/images/bg/03.jpg" class="d-block w-100" alt="Banner Image">
        </div>
      
      </div>

      <div class="carousel-item active">
        <div class="carousel-bg">
          <img src="../../assets/images/bg/04.jpg" class="d-block w-100" alt="Banner Image">
        </div>

      </div>

      <div class="carousel-item">
        <div class="carousel-bg">
          <img src="../../assets/images/bg/05.jpg" class="d-block w-100" alt="Banner Image">
        </div>

      </div>

      <div class="carousel-item">
        <div class="carousel-bg">
          <img src="../../assets/images/bg/06.jpg" class="d-block w-100" alt="Banner Image">
        </div>

      </div>

    </div>
  </div>

<div class="carousel-caption d-none d-md-block" style="bottom: inherit; top: 50%; transform: translateY(-50%);">
          <h4 style="color: #fff;">Cooperation Management Information System</h4>
          <p class="m-0" style="color: #fff;">Registration of NGO/Welfare Society (Act 2006)</p>
          <p style="color: #fff;">Registration of Cooperative Society (Act 1968)</p>
          <div class="d-flex align-items-center gap-2 justify-content-center" >
            <a  [routerLink]="['/login']" class="btn btn-primary " *ngIf="!isAuthenticated"><i class="bi bi-box-arrow-in-right"></i> Login</a>
            <a [routerLink]="['/societyRegistration']" class="btn btn-success "><i class="bi bi-pencil-square"></i> Register</a>
          </div>

        </div>

</div>
</section>

  <div class="ms-0 mt-3">
    <div class="row ">
      
      <div class="col-lg-12">
        <div class="container-fluid">
<div class="row society-verify-options">
          <div class="col-lg-2 col-md-4 col-6">
            <div class="card box-hover">
              <a href="javascript:void(0)">
                <div class="card-body">
                  <div class="text-center">
                    <div class="icon-box icon-box-lg bg-success-light rounded-circle">
                      <i class="bi bi-people"></i>
                    </div>
                    <div class="total-projects ">
                      <h3 class=" count">55927</h3>
                      <span>Total NGOs</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6">
            <div class="card box-hover">
             <a href="javascript:void(0)">
              <div class="card-body">
                <div class="text-center">
                  <div class="icon-box icon-box-lg bg-primary-light rounded-circle">
                    <i class="fa fa-female" style="line-height: 75px;"></i>
                  </div>
                  <div class="total-projects ">
                    <h3 class=" count">11175</h3>
                    <span>Mahila Mandals</span>
                  </div>
                </div>
              </div>
             </a>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6">
            <div class="card box-hover">
              <a href="javascript:void(0)">
                <div class="card-body">
                  <div class="text-center">
                    <div class="icon-box icon-box-lg bg-purple-light rounded-circle">
                      <i class="fa fa-male" style="line-height: 75px;"></i>
                    </div>
                    <div class="total-projects ">
                      <h3 class=" count">4723</h3>
                      <span>Yuvak Mandals</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6">
            <div class="card box-hover">
              <a href="javascript:void(0)">
                <div class="card-body">
                  <div class="text-center">
                    <div class="icon-box icon-box-lg bg-danger-light rounded-circle">
                      <i class="fa fa-university" style="line-height: 75px;"></i>
                    </div>
                    <div class="total-projects ">
                      <h3 class=" count">5471</h3>
                      <span>Cooperative Societies</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6">
            <div class="card box-hover">
              <a href="javascript:void(0)">
                <div class="card-body">
                  <div class="text-center">
                    <div class="icon-box icon-box-lg bg-warning-light rounded-circle">
                      <i class="bi bi-file-earmark-text"></i>
                    </div>
                    <div class="total-projects ">
                      <h3 class=" count">0</h3>
                      <span>Arbitration Cases Filed</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6">
            <div class="card box-hover">
              <a href="javascript:void(0)">
                <div class="card-body">
                  <div class="text-center">
                    <div class="icon-box icon-box-lg bg-info-light rounded-circle">
                     <i class="bi bi-check-square"></i>
                    </div>
                    <div class="total-projects">
                      <h3 class="count">0</h3>
                      <span>Arbitration Cases Decided</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
</div>
      </div>

<div class="col-lg-12">
<div >
<div class="row">
    <div class="col-lg-12">
<section class="">
<div class="container-fluid">
<div class="row">
  <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <ul class="nav nav-pills justify-content-start mb-0 nav-pills-contents">
<li class="nav-item m-1">
                <a
                  href="#navpills2-2"
                  class="nav-link active"
                  data-bs-toggle="tab"
                  aria-expanded="false"
                  >Registration of Cooperative Society (Act 1968)</a
                >
              </li>
              <li class="nav-item m-1">
                <a
                  href="#navpills2-1"
                  class="nav-link "
                  data-bs-toggle="tab"
                  aria-expanded="false"
                  >Registration of NGO/Welfare Society (Act 2006)</a
                >
              </li>
                <li class="nav-item m-1">
                            <a [routerLink]="['/ocr']"
                              class="btn btn-info wid-100"
                              alt="Data Extraction"
                            >
                              <i class="bi bi-box-arrow-in-right me-1"></i>
                              </a
                            >
                          </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="tab-content">
          <div id="navpills2-1" class="tab-pane ">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-xl-4 col-md-6">
                        <p>
                          The Himachal Pradesh Societies Registration Act, 2006
                          is an Act to provide for the registration and working
                          of literary, scientific, educational, religious,
                          charitable or other Societies in the State of Himachal
                          Pradesh.
                        </p>
                      </div>

                      <div class="col-xl-5 col-md-6">
                        <div class="table-responsive">
                          <table class="table header-border">
                            <tbody>
                              <tr class="table-primary">
                                <td>
                                  Time limit as per Public Service Guarantee Act
                                </td>
                                <td>21 Days</td>
                              </tr>
                              <tr class="table-warning">
                                <td>Time limit after removing objections</td>
                                <td>15 Days</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="col-xl-3 col-md-6">
                        <ul
                          class="list-group"
                          style="list-style: none; text-align: center"
                        >
                          <li>
                            <a
                              href="../../assets/society-sample/Act_2006.pdf" target="_blank"
                              class="btn btn-primary wid-100 mb-3"
                              ><i class="bi bi-binoculars-fill me-1"></i>View
                              Registration Act</a
                            >
                          </li>
                          <li>
                            <a [routerLink]="['/login']"
                              class="btn btn-info wid-100"
                            >
                              <i class="bi bi-box-arrow-in-right me-1"></i>
                              Login/ Register Online</a
                            >
                          </li>
                        
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <div class="col-xl-6 col-sm-12">
                <div
                  class="card-header border-0 px-0 pt-0 d-flex align-items-center justify-content-between mb-3"
                >
                  <h5 class="heading mb-0 blog-title">Online Applications</h5>
                  <small>Last Updated: 24-12-2024 10:21 AM</small>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover" (click)="openModal('societyModel','2006')">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-success-light rounded-circle"
                          >
                            <i
                              class="bi bi-journals text-success"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-success count">14511</h5>
                            <span>Applications Submitted</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-primary-light rounded-circle"
                          >
                            <i
                              class="bi bi-journal-check text-primary"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-primary count">9374</h5>
                            <span>Applications Approved</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-purple-light rounded-circle"
                          >
                            <i
                              class="bi bi-patch-check-fill text-purple"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-purple count">9374</h5>
                            <span>eCertificates Issued</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-danger-light rounded-circle"
                          >
                            <i
                              class="bi bi-person-vcard-fill text-danger"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-danger count">9374</h5>
                            <span>Fee Submitted & Verified</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-warning-light rounded-circle"
                          >
                            <i
                              class="bi bi-currency-rupee text-warning"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-warning count">396</h5>
                            <span>Average Fee/Application</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-sm-12">
                <div class="card-header border-0 px-0 pt-0 mb-3">
                  <h5 class="heading mb-0 blog-title">Registration Time</h5>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-success-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-success"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-success fs-15">
                              93 day(s) 23.3 hr(s)
                            </h5>
                            <span>Average Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-primary-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-primary"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-primary fs-15">
                              36 day(s) 9.1 hr(s)
                            </h5>
                            <span>Median Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-purple-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-purple"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-purple fs-15">0.6 hr(s)</h5>
                            <span>Minimum Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-danger-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-danger"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-danger fs-15">
                              1571 day(s) 23.4 hr(s)
                            </h5>
                            <span>Maximum Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="navpills2-2" class="tab-pane active">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-xl-4 col-md-6">
                        <p>
                          The Himachal Pradesh Co-operative Societies Act, 1968
                          is an Act to register, consolidate and amend the law
                          relating to Co-operative societies in the State of
                          Himachal Pradesh.
                        </p>
                      </div>

                      <div class="col-xl-5 col-md-6">
                        <div class="table-responsive">
                          <table class="table header-border">
                            <tbody>
                              <tr class="table-primary">
                                <td>
                                  Time limit as per Public Service Guarantee Act
                                </td>
                                <td>21 Days</td>
                              </tr>
                              <tr class="table-warning">
                                <td>Time limit after removing objections</td>
                                <td>15 Days</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="col-xl-3 col-md-6">
                        <ul
                          class="list-group"
                          style="list-style: none; text-align: center"
                        >
                          <li>
                            <a
                              href="../../assets/society-sample/Act_1968.pdf" target="_blank"
                              class="btn btn-primary wid-100 mb-3"
                              ><i class="bi bi-binoculars-fill me-1"></i>View
                              Registration Act</a
                            >
                          </li>
                          <li>
                            <a
                              [routerLink]="['/login']"
                              class="btn btn-info wid-100"
                              ><i class="bi bi-box-arrow-in-right me-1"></i>
                              Login/ Register Online</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-sm-12">
                <div
                  class="card-header border-0 px-0 pt-0 d-flex align-items-center justify-content-between mb-3"
                >
                  <h5 class="heading mb-0 blog-title">Online Applications</h5>
                  <small>Last Updated: 24-12-2024 10:21 AM</small>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover" (click)="openModal('societyModel','1968')">
                      <div class="card-body">
                  
                                    
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-success-light rounded-circle"
                          >
                            <i
                              class="bi bi-folder-fill text-success"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3" >
                            <h3 class="text-success count">1435</h3>
                            <span>Applications Submitted</span>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-primary-light rounded-circle"
                          >
                            <i
                              class="bi bi-file-check-fill text-primary"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h3 class="text-primary count">664</h3>
                            <span>Applications Approved</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-purple-light rounded-circle"
                          >
                            <i
                              class="bi bi-patch-check-fill text-purple"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h3 class="text-purple count">664</h3>
                            <span>eCertificates Issued</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-danger-light rounded-circle"
                          >
                            <i
                              class="bi bi-hand-thumbs-down-fill text-danger"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h3 class="text-danger count">119</h3>
                            <span>Applications Rejected</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-sm-12">
                <div class="card-header border-0 px-0 pt-0 mb-3">
                  <h5 class="heading mb-0 blog-title">Registration Time</h5>
                </div>

                <div class="row">
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-success-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-success"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-success fs-15">
                              34 day(s) 19.0 hr(s)
                            </h5>
                            <span>Average Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-primary-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-primary"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-primary fs-15">
                              36 day(s) 9.1 hr(s)
                            </h5>
                            <span>32 day(s) 15.3 hr(s)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-purple-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-purple"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-purple fs-15">0.8 hr(s)</h5>
                            <span>Minimum Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-sm-6">
                    <div class="card box-hover">
                      <div class="card-body">
                        <div class="d-flex align-items-center">
                          <div
                            class="icon-box icon-box-lg bg-danger-light rounded-circle"
                          >
                            <i
                              class="bi bi-calendar2-week-fill text-danger"
                              style="font-size: 30px; line-height: 4.375rem"
                            ></i>
                          </div>
                          <div class="total-projects ms-3">
                            <h5 class="text-danger fs-15">
                              274 day(s) 23.7 hr(s)
                            </h5>
                            <span>Maximum Registration Time</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
</div>
</section>
</div>

      <div class="col-lg-12">
<section>
<div class="container-fluid">
<div class="row">
<div class="col-lg-4 col-sm-6">
        <div class="card notification-bell-hp">
          <div class="card-header border-0">
            <h5 class="m-0"><span class="swinging-bell d-inline-block"><i class="bi bi-bell me-1"></i></span>
              Notification</h5>
          </div>
          <div class="card-body">
            <div class="basic-list-group">
              <div class="list-group list-group-notification notification-bell-content" style="height: 455px;">

                <img src="../../assets/images/Notification.png" class="img-fluid" alt="Notification Image" /> 
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6">
        <div class="card" style="min-height: 530px;">
          <div class="card-header border-0 blog-title">
            <h5 class="heading mb-0 blog-title"><i class="bi bi-calendar3 me-1"></i> Upcoming Holidays</h5>
          </div>
          <div class="card-body schedules-cal p-2">
            <div class="container mt-4">
              <div class="calendar-header d-flex justify-content-between align-items-center">
                <button class="btn " (click)="changeMonth(-1)">❮</button>
                <h6 class="fw-bold m-0">{{ monthNames[currentMonth] }} - {{ currentYear }}</h6>
                <button class="btn" (click)="changeMonth(1)">❯</button>
              </div>
            
              <div class="week-header">
                <div>Sun</div>
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
              </div>
            
              <div class="calendar-grid">
                <div *ngFor="let day of daysInMonth" class="calendar-day"
                     [class.holiday-bg]="day?.holiday"
                     [style.--event-color]="day?.holiday?.sEventColor"
                     (click)="openHolidayModal(day?.holiday)"
                     [attr.data-bs-toggle]="day?.holiday ? 'tooltip' : null"
                     [attr.title]="day?.holiday?.name">
                  <span *ngIf="day">{{ day.day }}</span>
                </div>
              </div>
               <div class="modal fade" id="holidayModal" tabindex="-1" aria-labelledby="holidayModalLabel"
            aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header" *ngIf="selectedHoliday">
                  <h5 class="modal-title" id="holidayModalLabel">{{ selectedHoliday.name }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" *ngIf="selectedHoliday">
                  {{ selectedHoliday.sEventDescription }}
                </div>
              </div>
            </div>
          </div>
            </div>
            
            
            
            
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-sm-12">
        <div class="card">
          <div class="card-header border-0">
            <h5 class="heading mb-0 blog-title"><i class="bi bi-chat-left-dots me-1"></i> Administration Message</h5>
          </div>

          <div class="card-body text-center p-4 message-carousel">
            <div
              id="carouselExampleSlidesOnly"
              class="carousel slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class="message-image">
                    <img src="../../assets/images/avatar/6.jpg" />
                  </div>
                  <div class="media-body" style="height: 380px; overflow-x: auto;">
                    <h4 class="mb-0">Mr. Mukesh Agnihotri</h4>
                    <p class="designation">Hon'ble Cooperation Minister</p>

                    <p
                      class="mb-0 fs-15 text-black text-start paragrapgh-Message"
                    >
                      The Co-operative Societies are the fundamental units of
                      democracy and self reliance. The stage of Cooperative
                      movement in a State thus, reflects the level of democratic
                      ideals in political governance. Himachal Pradesh has
                      pioneered in Co-operative movement in 1904 and now with
                      5038 Societies it reflects the public sentiment in self
                      governance over the years. The Department of Cooperation
                      has come out with a dedicated and interactive web-site for
                      the use of public as well as other Govt. departments. My
                      best wishes to the Department of Cooperation and the
                      Cooperatives of the State.
                    </p>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="message-image">
                    <img src="../../assets/images/avatar/7.jpg" />
                  </div>
                  <div class="media-body" style="height: 380px; overflow-x: auto;">
                    <h4 class="mb-0">Sh. C. Paulrasu</h4>
                    <p class="designation">IAS (Secretary Cooperation)</p>

                    <p
                      class="mb-0 fs-15 text-black text-start paragrapgh-Message"
                    >
                      The Department of Cooperation ever since its inception has
                      shown great responsibility towards public service. From
                      the level of preliminary non-credit Primary Cooperative
                      Societies, the Cooperative movement in the State has
                      developed into multifaceted structure of credit
                      institutions viz Cooperative Banks and Federations. With
                      the launch of the dedicated and function specific
                      web-site, the Department of Cooperation has made another
                      endeavor to reach to the public and provide them platform
                      for general information of the department. The site will
                      provide the maximum information which the public would
                      like to know about the department and the Co-operative
                      Societies.
                    </p>
                  </div>
                </div>
                <div class="carousel-item">
                  <div class="message-image">
                    <img src="../../assets/images/avatar/8.jpg" />
                  </div>
                  <div class="media-body" style="height: 380px; overflow-x: auto;">
                    <h4 class="mb-0">Dr. RK Pruthi</h4>
                    <p class="designation">Registrar Cooperative Societies</p>

                    <p
                      class="mb-0 fs-15 text-black text-start paragrapgh-Message"
                    >
                      Welcome to the website of the Department of Cooperation
                      H.P. The Department of Cooperation plays an important role
                      to eliminate exploitation of common man by middleman and
                      money leaders by ensuring credit facilities to farmers at
                      low rate of interest through cooperatives, focus being to
                      ameliorate socio-economic condition of the people.
                      Himachal Pradesh has pioneered in cooperative movement in
                      1904 and now 5038 cooperatives of various kinds are
                      functioning in the State. These cooperatives are providing
                      multi farious services to the people of the State which
                      includes distribution of consumer goods under PDS,
                      Distribution of fertilizers and other agricultural related
                      inputs and implements, collection of milk and its
                      marketing through mild cooperatives and Milk Fed,
                      advancement of S.T., M.T loans through PACS and other
                      cooperative financial institutions, marketing of
                      agricultural and horticultural produces, production of
                      hand-loom and handicraft products, fisheries,
                      transportation services through transport cooperatives
                      etc. I am glad to bring it to the notice of general public
                      that the Department has started online registration of the
                      societies under the provision of H.P. Societies
                      Registration Act, 2006.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
</div>
</section>
</div>
</div>
</div>
</div>

    </div>
  </div>




<div
*ngIf="showModal"
@slideDownUp
class="modal fade show d-block"
tabindex="-1"
role="dialog"
aria-modal="true"
style=" border-radius: 8px;   box-shadow: 0 2px 10px rgba(0,0,0,0.3);"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="applicationModalLabel">{{modalHeader}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="toggleModal()"></button>
      </div>

      <div class="modal-body">
    
        <div  *ngIf="rows && rows.length >0">
          <app-application-list-model [columns]="columns" [data]="rows"></app-application-list-model>

          </div>
     
        <div class="text-center my-3">
          <button class="btn btn-outline-success" (click)="toggleChart()">
            {{ showChart ? 'Hide Chart' : 'View Chart' }}
          </button>
        </div>

     
        <div *ngIf="showChart" #chartSection>
          <app-bar-chart
            [ChartOptions]="ChartOptions"
            style="display: block; width: 100%; height: 400px;"
          ></app-bar-chart>
        </div>
      </div>
    </div>
  </div>
</div>
 -->






<style>
  @keyframes progress {
    0% {
      width: 0;
    }

    100% {
      width: 100%;
    }
  }

  .slide {
    display: none;
    position: relative;
    width: 100%;
  }

  .slide.active {
    display: block;
  }

  .slider-progress .progress-bar {
    width: 0;
    height: 4px;
    background-color: #007bff;
  }

  .message-scroll {
    max-height: 260px;
    overflow-y: auto;
    padding-right: 6px;
  }

  .message-scroll::-webkit-scrollbar {
    width: 4px;
  }

  .message-scroll::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  .fs-15 {
    font-size: 15px;
  }

  .carousel-item p {
    max-height: 200px;
    overflow-y: auto;
    padding-right: 8px;
  }

  #adminMessageCarousel .carousel-inner {
    min-height: 250px;
    /* or suitable height */
  }

  #adminMessageCarousel .carousel-item {
    padding: 1rem;
    min-height: 250px;
  }
</style>


<!-- Hero Slider Section -->
<section class="hero-slider" id="heroSlider" *ngIf="!isAuthenticated">
  <div #slidesContainer class="slider-container slides">

    <!-- Slide 1 -->
    <div class="slide active" data-slide="0">
      <div class="slide-bg">
        <img src="../../assets/images/bg/03.jpg" class="d-block w-100" alt="Cooperative Department Banner">
      </div>
      <div class="slide-pattern"></div>
      <div class="container">
        <div class="slide-content">
          <h1 class="slide-title">
            Empowering <span class="gradient-text">Cooperative Societies</span>
          </h1>
          <p class="slide-desc">
            Strengthening cooperative institutions through transparent governance,
            digital services, and inclusive development across Himachal Pradesh.
          </p>

          <!-- Call to Action -->
          <div class="slide-cta mt-4 flex gap-3">
            <!-- <a href="#" [routerLink]="['/aboutus']" class="btn btn-secondary">
              <i class="bi bi-rocket-takeoff"></i>
              Get Started
            </a> -->
            <a href="#" class="btn btn-primary" [routerLink]="['/societyRegistration']">
              <i class="bi bi-person-plus"></i>
              Register
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 2 -->
    <div class="slide" data-slide="1">
      <div class="slide-bg">
        <img src="../../assets/images/bg/04.jpg" class="d-block w-100" alt="Society Registration">
      </div>
      <div class="slide-pattern"></div>
      <div class="container">
        <div class="slide-content">
          <h1 class="slide-title">
            Online <span class="gradient-text">Society Registration</span>
          </h1>
          <p class="slide-desc">
            Register cooperative societies through a simple, secure,
            and fully online process with faster approvals.
          </p>

          <!-- Call to Action -->
          <div class="slide-cta mt-4 flex gap-3">
            <!-- <a href="#" [routerLink]="['/aboutus']" class="btn btn-secondary">
              <i class="bi bi-rocket-takeoff"></i>
              Get Started
            </a> -->
            <a href="#" class="btn btn-primary" [routerLink]="['/societyRegistration']">
              <i class="bi bi-person-plus"></i>
              Register 
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 3 -->
    <div class="slide" data-slide="2">
      <div class="slide-bg">
        <img src="../../assets/images/bg/05.jpg" class="d-block w-100" alt="Member Services">
      </div>
      <div class="slide-pattern"></div>
      <div class="container">
        <div class="slide-content">
          <h1 class="slide-title">
            Serving <span class="gradient-text">Members & Societies</span>
          </h1>
          <p class="slide-desc">
            Access member services, certificates, annual returns,
            and cooperative records through a unified digital platform.
          </p>

          <!-- Call to Action -->
          <div class="slide-cta mt-4 flex gap-3">
            <!-- <a href="#" [routerLink]="['/aboutus']" class="btn btn-secondary">
              <i class="bi bi-rocket-takeoff"></i>
              Get Started
            </a> -->
            <a href="#" class="btn btn-primary" [routerLink]="['/societyRegistration']">
              <i class="bi bi-person-plus"></i>
              Register 
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Slide 4 -->
    <div class="slide" data-slide="3">
      <div class="slide-bg">
        <img src="../../assets/images/bg/06.jpg" class="d-block w-100" alt="Digital Governance">
      </div>
      <div class="slide-pattern"></div>
      <div class="container">
        <div class="slide-content">
          <h1 class="slide-title">
            Digital <span class="gradient-text">Cooperative Governance</span>
          </h1>
          <p class="slide-desc">
            Enabling accountability, transparency, and efficiency
            in cooperative administration through modern digital tools.
          </p>

          <!-- Call to Action -->
          <div class="slide-cta mt-4 flex gap-3">
            <!-- <a href="#" [routerLink]="['/aboutus']" class="btn btn-secondary">
              <i class="bi bi-rocket-takeoff"></i>
              Get Started
            </a> -->
            <a href="#" class="btn btn-primary" [routerLink]="['/societyRegistration']">
              <i class="bi bi-person-plus"></i>
              Register 
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Slider Controls -->
  <!-- <div class="slider-controls">
    <button class="slider-btn prev" (click)="onPrevClick()">
      <i class="bi bi-chevron-left"></i>
    </button>
    <button class="slider-btn next" (click)="onNextClick()">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div> -->

  <!-- Slider Indicators -->
  <div class="slider-indicators">
    <button class="indicator active" (click)="onIndicatorClick(0)"></button>
    <button class="indicator" (click)="onIndicatorClick(1)"></button>
    <button class="indicator" (click)="onIndicatorClick(2)"></button>
    <button class="indicator" (click)="onIndicatorClick(3)"></button>
  </div>

  <!-- Progress Bar -->
  <div class="slider-progress">
    <div class="progress-bar" id="progressBar"></div>
  </div>
</section>


<!-- Services Section -->
<section class="services-section cta-actions" *ngIf="!isAuthenticated">
  <div class="container">

    <div class="section-header">
      <span class="section-tag">Registration Services</span>
      <h2 class="section-title">Society Registration Acts</h2>
      <p class="section-desc">
        Register cooperative societies and welfare organizations under applicable acts
      </p>
    </div>

     <div class="services-grid">

      <div class="service-card featured">
        <div class="service-bg"></div>

        <div class="service-content">
          <div class="service-icon">
            <i class="bi bi-bank"></i>
          </div>

          <h3>Cooperative Society</h3>
          <p>
            Registration under the Himachal Pradesh Co-operative Societies Act, 1968.
          </p>

          <ul class="list-unstyled small mb-3">
            <li><strong>PSG Time Limit:</strong> 21 Days</li>
            <li><strong>After Objections:</strong> 15 Days</li>
          </ul>

          <a href="../../assets/society-sample/Act_1968.pdf" target="_blank" class="service-link d-block mb-2">
            View Act <i class="bi bi-box-arrow-up-right"></i>
          </a>

          <a [routerLink]="['/societyRegistration']" class="service-link fw-bold">
            Apply Online <i class="bi bi-arrow-right"></i>
          </a>
        </div>
      </div>

      <div class="service-card">
        <div class="service-icon">
          <i class="bi bi-people"></i>
        </div>

        <h3>NGO / Welfare Society</h3>
        <p>
          Registration under the Himachal Pradesh Societies Registration Act, 2006.
        </p>

        <ul class="list-unstyled small mb-3">
          <li><strong>PSG Time Limit:</strong> 21 Days</li>
          <li><strong>After Objections:</strong> 15 Days</li>
        </ul>

        <a href="../../assets/society-sample/Act_2006.pdf" target="_blank" class="service-link d-block mb-2">
          View Act <i class="bi bi-box-arrow-up-right"></i>
        </a>

        <a [routerLink]="['/societyRegistration']" class="service-link fw-bold">
          Apply Online <i class="bi bi-arrow-right"></i>
        </a>
      </div>

       <!-- <div class="service-card">
        <div class="service-icon">
          <i class="bi bi-file-earmark-text"></i>
        </div>

        <h3>Data Extraction (OCR)</h3>
        <p>
          Upload documents and extract structured data automatically.
        </p>

        <a
          [routerLink]="['/ocr']"
          class="service-link fw-bold"
        >
          Start OCR <i class="bi bi-arrow-right"></i>
        </a>
      </div>  -->

     </div>
  </div>
</section>


<!-- About Section -->
<!-- <div class="row g-4" *ngIf="!isAuthenticated">
  <div class="col-lg-6 col-md-6 col-sm-12 d-flex" *ngFor="let card of cards">
    
    <div class="dashboard-card w-100">

    
      <div class="row">
        <div class="col-6 mb-3" *ngFor="let stat of [
          {icon:'bi-envelope-fill', label:'Applications Submitted', value:card.stats.submitted},
          {icon:'bi-check-circle-fill', label:'Applications Approved', value:card.stats.approved},
          {icon:'bi-patch-check-fill', label:'eCertificates Issued', value:card.stats.certificates}
        ]">
          <div class="mini-box">
            <i class="bi {{stat.icon}} stat-icon"></i>
            <div class="stat-label">{{ stat.label }}</div>
            <div class="stat-value">{{ stat.value | number }}</div>
          </div>
        </div>


        <div class="col-6 mb-3" *ngIf="card.stats.feeVerified">
          <div class="mini-box">
            <i class="bi bi-cash-stack stat-icon"></i>
            <div class="stat-label">Fee Submitted & Verified</div>
            <div class="stat-value">{{ card.stats.feeVerified | number }}</div>
          </div>
        </div>

        <div class="col-6 mb-3" *ngIf="card.stats.rejected">
          <div class="mini-box">
            <i class="bi bi-hand-thumbs-down-fill stat-icon"></i>
            <div class="stat-label">Applications Rejected</div>
            <div class="stat-value">{{ card.stats.rejected | number }}</div>
          </div>
        </div>

        <div class="col-6 mb-3" *ngIf="card.stats.avgFee">
          <div class="mini-box">
            <i class="bi bi-currency-rupee stat-icon"></i>
            <div class="stat-label">Average Fee/Application</div>
            <div class="stat-value">₹ {{ card.stats.avgFee | number }}</div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div> -->
<section class=""
>
<section class="stats-marquee-section coop-section" *ngIf="societyStats && societyStats.length">
  <div class="container-fluid p-0">

    <div class="section-title text-center mb-5">
      <h3>Region-wise Primary Co-operative Societies</h3>
    </div>

    <div class="marquee-wrapper">
      <div class="marquee-track">

        <!-- Repeat cards twice for smooth infinite scroll -->
        <div class="stat-card" *ngFor="let item of societyStats">
         <div class="icon-box">
    <i [class]="item.icon"></i>


  </div>
          <div>
            <h6>{{item.title}}</h6>
            <span>{{item.count}}</span>
          </div>
        </div>

        <div class="stat-card" *ngFor="let item of societyStats">
       <div class="icon-box">
    <i [class]="item.icon"></i>
  </div>
          <div>
            <h6>{{item.title}}</h6>
            <span>{{item.count}}</span>
          </div>
        </div>

      </div>
    </div>

  </div>
</section>
<section class="stats-marquee-section ngo-section" *ngIf="societyNgo && societyNgo.length>0">
  <div class="container-fluid p-0">

    <div class="section-title text-center mb-5">
      <h3>NGO / Welfare Society</h3>
    </div>

    <div class="marquee-wrapper">
      <div class="marquee-track">

        <!-- Repeat cards twice for smooth infinite scroll -->
        <div class="stat-card" *ngFor="let item of societyNgo">
         <div class="icon-box">
    <i [class]="item.icon"></i>


  </div>
          <div>
            <h6>{{item.title}}</h6>
            <span>{{item.count}}</span>
          </div>
        </div>

        <div class="stat-card" *ngFor="let item of societyNgo">
       <div class="icon-box">
    <i [class]="item.icon"></i>
  </div>
          <div>
            <h6>{{item.title}}</h6>
            <span>{{item.count}}</span>
          </div>
        </div>

      </div>
    </div>

  </div>
</section>

</section>



<!-- Quick Stats -->
<!-- <section class="stats-section my-4" *ngIf="!isAuthenticated">
  <div class="container">
    <div class="stats-grid">

      <div class="stat-item">
        <div class="stat-icon blue">
          <i class="bi bi-people"></i>
        </div>
        <div class="stat-number" data-count="55927">55,927</div>
        <div class="stat-label">Total NGOs</div>
      </div>

      <div class="stat-item">
        <div class="stat-icon pink">
          <i class="bi bi-person-fill"></i>
        </div>
        <div class="stat-number" data-count="11175">11,175</div>
        <div class="stat-label">Mahila Mandals</div>
      </div>

      <div class="stat-item">
        <div class="stat-icon green">
          <i class="bi bi-person-badge-fill"></i>
        </div>
        <div class="stat-number" data-count="4723">4,723</div>
        <div class="stat-label">Youth Mandals</div>
      </div>

      <div class="stat-item">
        <div class="stat-icon purple">
          <i class="bi bi-bank"></i>
        </div>
        <div class="stat-number" data-count="5471">5,471</div>
        <div class="stat-label">Cooperative Societies</div>
      </div>

    </div>
  </div>
</section> -->





<!-- News & Updates -->
<section class="news-section" *ngIf="!isAuthenticated">
  <div class="container">

    <!-- ✅ Center Heading -->
    <div class="section-header  mb-4 flex">
      <div>
      <h2 class="main-title">Notifications & Announcements</h2>
      <p class="sub-title">Latest updates and important notices</p>
      </div>

    </div>

    <div class="row g-4">
      
      <!-- LEFT: Notifications -->
      <div class="col-lg-6 col-md-12">
        <div class="news-wrapper">

          <div class="scroll-container" [class.expanded]="showAll">
            <article
  class="news-card"
  *ngFor="let item of visibleNotifications"
  (click)="downloadFile(item.link)"
  style="cursor:pointer;"
>
  <div class="news-header">
    <span class="date">
      <i class="bi bi-calendar3"></i>
      {{ item.date }}
    </span>
    <span class="tag">Notification</span>
  </div>

  <h3 class="title" [title]="item.title">
    {{ item.title }}
  </h3>

  <!-- <a
    [href]="item.link"
    target="_blank"
    class="file-link"
    (click)="$event.stopPropagation()"
  >
    <i class="bi bi-file-earmark-text"></i>
  </a> -->
</article>
          </div>

          <div class="view-all">
            <button (click)="toggleView()">
              {{ showAll ? 'Show Less' : 'View All Notifications' }}
            </button>
          </div>

        </div>
      </div>

      <!-- RIGHT: Chart / Component -->
      <div class="col-lg-6 col-md-12">
        <div class="chart-card">
          <app-societies-details ></app-societies-details>
        </div>
      </div>

    </div>
  </div>
</section>





<section class="news-section p-0 bg-transparent" *ngIf="!isAuthenticated">
    <div class="row g-4" style="margin-top: 10px;">
<div class="col-lg-4">
        <div class="card h-100">
          <div class="card-header border-0">
            <h5 class="heading mb-0 d-flex align-items-center gap-2">
              <i class="bi bi-calendar3 text-primary fs-5"></i>
              <span class="text-dark">Upcoming Holidays</span>
            </h5>
          </div>

          <div class="card-body schedules-cal p-2">

            <div class="calendar-header d-flex justify-content-between align-items-center mb-2">
              <button class="btn btn-sm" (click)="changeMonth(-1)">❮</button>
              <h6 class="fw-bold m-0">
                {{ monthNames[currentMonth] }} - {{ currentYear }}
              </h6>
              <button class="btn btn-sm" (click)="changeMonth(1)">❯</button>
            </div>

            <div class="week-header" style="margin-bottom: 10px;">
              <div>Sun</div>
              <div>Mon</div>
              <div>Tue</div>
              <div>Wed</div>
              <div>Thu</div>
              <div>Fri</div>
              <div>Sat</div>
            </div>

            <div class="calendar-grid">

              <div *ngFor="let day of daysInMonth" [ngStyle]="{
      'background-color':
        day?.isSunday
            ? '#ff4d4f'
            : '',
      'color':
       day?.isSunday
          ? '#ffffff'
          : ''
    }" class="calendar-day" [class.holiday-bg]="day?.holiday"

                [style.--event-color]="day?.holiday?.sEventColor"               [attr.data-bs-toggle]="day?.holiday ? 'tooltip' : null"  (click)="openHolidayModal(day?.holiday)"
                [attr.title]="day?.holiday?.name">
                <span *ngIf="day">{{ day.day }}</span>
              </div>
            </div>
<div class="modal fade" id="holidayModal" tabindex="-1" aria-labelledby="holidayModalLabel"
            aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header" *ngIf="selectedHoliday">
                  <h5 class="modal-title" id="holidayModalLabel">{{ selectedHoliday.name }}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" *ngIf="selectedHoliday">
                  {{ selectedHoliday.sEventDescription }}
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
       <div class="col-lg-8">
        <!-- <div class="bg-white shadow rounded-lg h-full flex flex-col">

       
          <div class="bg-blue-600 text-white px-4 py-3 flex justify-between items-center" style="color: #163461;">
            <div class="d-flex align-items-center gap-2">
              <i class="bi bi-chat-left-dots"></i>
              <h5 class="mb-0 fw-semibold">Message from our Administration</h5>
            </div>


            <div class="flex gap-2">
              <button (click)="prev()" class="bg-white/20 px-2 py-1 rounded">◀</button>
              <button (click)="next()" class="bg-white/20 px-2 py-1 rounded">▶</button>
            </div>
          </div>

          <div class="p-4 relative overflow-hidden">

            <div class="flex transition-transform duration-500"
              [style.transform]="'translateX(-' + currentIndex * 100 + '%)'">

              <div class="min-w-full flex justify-center items-center" *ngFor="let msg of messages">

                <div class="flex items-center gap-4 max-w-2xl">

                  <img [src]="msg.image" class="w-16 h-16 rounded-full object-cover shrink-0" style="height: 137px;
    width: 148px;" />

                  <div class="text-sm text-center">
                    <h6 class="font-semibold">{{msg.name}}</h6>
                    <p class="text-gray-500 text-xs">{{msg.designation}}</p>

                    <p class="mt-2 text-gray-700 max-w-md">
                      {{msg.text}}
                    </p>
                  </div>

                </div>

              </div>

            </div>



          </div>
        </div> -->
      
      
 
  <div class="admin-card">

    <!-- Header -->
    <div class="admin-header">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-chat-left-dots-fill"></i>
        <h5 class="mb-0">Message from our Administration</h5>
      </div>

      <div>
        <button class="nav-btn me-2" (click)="prev()">
          <i class="bi bi-chevron-left"></i>
        </button>

        <button class="nav-btn" (click)="next()">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="admin-body">

      <div
        class="admin-slide"
        *ngFor="let msg of messages; let i=index"
        [hidden]="i !== currentIndex"
      >

        <!-- Image -->
        <div class="admin-image">
          <img [src]="msg.image" />
        </div>

        <!-- Details -->
        <div class="admin-content">

          <h4>{{msg.name}}</h4>

          <p class="designation">
            {{msg.designation}}
          </p>

          <p class="message-text">
            {{msg.text}}
          </p>

        </div>

      </div>

    </div>

  </div>
</div>
      
   
      </div>
      <!-- UPCOMING HOLIDAYS -->
      

      <!-- ADMINISTRATION MESSAGE -->

      <!-- <div class="col-lg-4 col-sm-12">
  <div class="card h-100 shadow-sm">
    <div class="card-header border-0 bg-primary text-white">
      <h5 class="mb-0 d-flex align-items-center">
        <i class="bi bi-chat-left-dots me-2"></i> Administration Message
      </h5>
    </div>

    <div class="card-body p-3" style="min-height: 320px;">

      <div id="adminMessageCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">

        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="message-image">
              <img src="../../assets/images/avatar/6.jpg" />
            </div>
            <div class="media-body" style="height: 380px; overflow-x: auto;">
              <h4 class="mb-0">Mr. Mukesh Agnihotri</h4>
              <p class="designation">Hon'ble Cooperation Minister</p>

              <p class="mb-0 fs-15 text-black text-start paragrapgh-Message">
                The Co-operative Societies are the fundamental units of
                democracy and self reliance. The stage of Cooperative
                movement in a State thus, reflects the level of democratic
                ideals in political governance. Himachal Pradesh has
                pioneered in Co-operative movement in 1904 and now with
                5038 Societies it reflects the public sentiment in self
                governance over the years. The Department of Cooperation
                has come out with a dedicated and interactive web-site for
                the use of public as well as other Govt. departments. My
                best wishes to the Department of Cooperation and the
                Cooperatives of the State.
              </p>
            </div>
          </div>
          <div class="carousel-item">
            <div class="message-image">
              <img src="../../assets/images/avatar/7.jpg" />
            </div>
            <div class="media-body" style="height: 380px; overflow-x: auto;">
              <h4 class="mb-0">Sh. C. Paulrasu</h4>
              <p class="designation">IAS (Secretary Cooperation)</p>

              <p class="mb-0 fs-15 text-black text-start paragrapgh-Message">
                The Department of Cooperation ever since its inception has
                shown great responsibility towards public service. From
                the level of preliminary non-credit Primary Cooperative
                Societies, the Cooperative movement in the State has
                developed into multifaceted structure of credit
                institutions viz Cooperative Banks and Federations. With
                the launch of the dedicated and function specific
                web-site, the Department of Cooperation has made another
                endeavor to reach to the public and provide them platform
                for general information of the department. The site will
                provide the maximum information which the public would
                like to know about the department and the Co-operative
                Societies.
              </p>
            </div>
          </div>
          <div class="carousel-item">
            <div class="message-image">
              <img src="../../assets/images/avatar/8.jpg" />
            </div>
            <div class="media-body" style="height: 380px; overflow-x: auto;">
              <h4 class="mb-0">Dr. RK Pruthi</h4>
              <p class="designation">Registrar Cooperative Societies</p>

              <p class="mb-0 fs-15 text-black text-start paragrapgh-Message">
                Welcome to the website of the Department of Cooperation
                H.P. The Department of Cooperation plays an important role
                to eliminate exploitation of common man by middleman and
                money leaders by ensuring credit facilities to farmers at
                low rate of interest through cooperatives, focus being to
                ameliorate socio-economic condition of the people.
                Himachal Pradesh has pioneered in cooperative movement in
                1904 and now 5038 cooperatives of various kinds are
                functioning in the State. These cooperatives are providing
                multi farious services to the people of the State which
                includes distribution of consumer goods under PDS,
                Distribution of fertilizers and other agricultural related
                inputs and implements, collection of milk and its
                marketing through mild cooperatives and Milk Fed,
                advancement of S.T., M.T loans through PACS and other
                cooperative financial institutions, marketing of
                agricultural and horticultural produces, production of
                hand-loom and handicraft products, fisheries,
                transportation services through transport cooperatives
                etc. I am glad to bring it to the notice of general public
                that the Department has started online registration of the
                societies under the provision of H.P. Societies
                Registration Act, 2006.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div> -->
      <!-- <div class="col-lg-4 col-sm-6">
        <div class="card notification-bell-hp">
          <div class="card-header border-0">
            <h5 class="m-0"><span class="swinging-bell d-inline-block"><i class="bi bi-bell me-1"></i></span>
              Notification</h5>
          </div>
          <div class="card-body">
            <div class="basic-list-group">
              <div class="list-group list-group-notification notification-bell-content" style="height: 455px;">

                <img src="../../assets/images/Notification.png" class="img-fluid" alt="Notification Image" /> 
              </div>
            </div>
          </div>
        </div>
      </div> -->

     
  

</section>


<!-- CTA Section -->
<section class="cta-section d-none" *ngIf="!isAuthenticated">
  <div class="cta-bg"></div>
  <div class="container">
    <div class="cta-content">
      <h2>Ready to Register Your Society?</h2>
      <p>Join thousands of cooperative societies benefiting from our digital services</p>
      <div class="cta-actions">

        <a [routerLink]="['/societyRegistration']" class="btn btn-white">
          <i class="bi bi-rocket-takeoff"></i> Start Registration
        </a>

        <a href="#" class="btn btn-ghost-white" [routerLink]="['/contact']">
          <i class="bi bi-telephone"></i>
          Contact Support
        </a>
      </div>
    </div>
  </div>
</section>



<!-- Back to Top -->
<button class="back-to-top" id="backToTop">
  <i class="bi bi-chevron-up"></i>
</button>